import React, { useState, FC, useEffect } from "react";
import { navigate } from "gatsby";
import { User } from "../../../models/user";
import Loading from "../../loading/loading";
import ExpandRowWithBtn from "../../common/expand/expandRowWithBtn";
import ExpandRow from "../../common/expand/expandRow";
import Preview from "../../album/preview";
import { FullAlbumDetails } from "../../../models/exports";

interface CreatedAlbumsProps {
  createdAlbums: FullAlbumDetails[];
  loading: boolean;
  profilePage?: boolean;
}

const CreatedAlbums: FC<CreatedAlbumsProps> = ({
  createdAlbums,
  loading,
  profilePage = false,
}) => {
  if (loading) {
    return (
      <div className="flex flex-col w-full">
        <div className="flex flex-col mx-auto">
          <div className="mt-16 mx-auto">
            <Loading />
          </div>
        </div>
        <div
          className="flex flex-row w-full bg-primary-dark-grey my-32"
          style={{ height: "1px" }}
        />
      </div>
    );
  }

  let createdAlbumsSection = (
    <>
      <div className="mt-4 grid sm:grid-cols-1 md:grid-cols-2 xlg:grid-cols-3 gap-16 lg:gap-28 xlg:gap-24 sm:pt-16 md:pt-0">
        {createdAlbums.map((album) => (
          <div className="flex" key={album.name} style={{ height: "216px" }}>
            <Preview
              owner={album.creator}
              address={album.albumAddress}
              id={album.id}
              name={album.name}
              symbol={album.tokenName}
              nfts={album.nfts}
              slim={true}
            />
          </div>
        ))}
      </div>
    </>
  );

  if (!profilePage) {
    return (
      <div className="flex flex-col w-full">
        <ExpandRowWithBtn
          label={
            createdAlbums?.length > 0
              ? `${createdAlbums.length} created`
              : "No albums created yet"
          }
          defaultOpen={true}
          buttonText="Create new album"
          onClick={() => navigate("/account/create")}
        >
          {createdAlbumsSection}
        </ExpandRowWithBtn>
        <div
          className="flex flex-row w-full bg-primary-dark-grey my-32"
          style={{ height: "1px" }}
        />
      </div>
    );
  } else {
    return (
      <div className="flex flex-col w-full">
        <ExpandRow
          label={
            createdAlbums?.length > 0
              ? `${createdAlbums.length} created`
              : "No albums created yet"
          }
          defaultOpen={true}
        >
          {createdAlbumsSection}
        </ExpandRow>
        <div
          className="flex flex-row w-full bg-primary-dark-grey my-32"
          style={{ height: "1px" }}
        />
      </div>
    );
  }
};

export default CreatedAlbums;
